/**
 * Retail / storefront title case for labels shown to customers (categories, product types,
 * hub tiles, breadcrumbs). Each word is capitalized; hyphen-separated segments are handled;
 * pure numeric tokens are unchanged. Does not modify stored catalog data.
 */
export function formatDisplayTitle(text) {
  if (text == null || typeof text !== 'string') return '';
  let t = text.trim();
  if (!t) return '';
  t = t.replace(/\s*[\u2013\u2014]\s*/g, ' ');

  return t.replace(/[^\s-]+/g, (word) => {
    if (!word) return word;
    const first = word.charAt(0);
    const rest = word.slice(1);
    if (/^\d+$/.test(word)) return word;
    return first.toUpperCase() + rest.toLowerCase();
  });
}

/** @deprecated Use formatDisplayTitle; kept for existing imports. */
export const formatProductTitle = formatDisplayTitle;
